import React, {useEffect} from "react";
import api from "../../api";
import {Button} from "antd";
import CdnImage from "../CdnImage";

export default function CdnImageUpload({onUploaded, imageUrl = null}) {

    const [uploadedFile, setUploadedFile] = React.useState(imageUrl);
    const [isLoading, setIsLoading] = React.useState(false);
    const inputRef = React.useRef();

    function handleUpload(event) {
        event.preventDefault();
        setIsLoading(true)
        api.uploadToCdn(event.target.files[0]).then((url) => {
            setUploadedFile(url);
            if (onUploaded) {
                onUploaded(url);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        if (imageUrl) {
            setUploadedFile(imageUrl);
        }
    }, [imageUrl]);

    function triggerFileInput() {
        inputRef.current?.click();
    }

    return (
        <>
            <div className={"mar-b-1"}>
                <label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleUpload}
                        ref={inputRef}
                        style={{display: "none"}}
                    />
                    <Button className={"mar-r-1"} loading={isLoading}
                            onClick={triggerFileInput}>{uploadedFile ? 'Andere afbeelding' : 'Kies afbeelding'}</Button>
                </label>
                {uploadedFile && <Button onClick={() => {
                    setUploadedFile(null);
                    if (onUploaded) {
                        onUploaded(null);
                    }
                }} className={"mar-r-1"}>Verwijder</Button>}
            </div>

            {uploadedFile &&
                <CdnImage src={uploadedFile} width={100} height={100}/>}

        </>
    )
}